import { render, staticRenderFns } from "./InceptionCandidateDashboard.vue?vue&type=template&id=0a6d622e&scoped=true"
import script from "./InceptionCandidateDashboard.vue?vue&type=script&lang=ts"
export * from "./InceptionCandidateDashboard.vue?vue&type=script&lang=ts"
import style0 from "./InceptionCandidateDashboard.vue?vue&type=style&index=0&id=0a6d622e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d622e",
  null
  
)

export default component.exports